import React from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'
import { PrimaryButton } from 'shared/components/button'
import ErrorMessageRhf from 'shared/components/error-message-rhf'
import FormInputRhf from 'shared/components/form-input-rhf'
import { AuthFormHeader } from 'modules/authentication/components/auth-form-header'
import { AuthFormLayout } from 'modules/authentication/components/auth-form-layout'
import { DEFAULT_AUTH_FORM_CLASSES } from 'modules/authentication/const/default-classes'
import { useRegisterForm } from '../hooks/use-register-form'

export const RegisterFormDashboard = () => {
  const { t } = useTranslation()

  const { handleSubmit, control, setValue, errors, isLoading, onSubmit } = useRegisterForm()

  return (
    <>
      <AuthFormHeader title={t('modal.registraion.title')} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <AuthFormLayout
          body={
            <>
              <FormInputRhf
                type="email"
                name="email"
                className={DEFAULT_AUTH_FORM_CLASSES.INPUT_WRAPPER}
                inputClassName={DEFAULT_AUTH_FORM_CLASSES.INPUT}
                label={t('security.login.username')}
                control={control}
                setValue={setValue}
                maxLength={180}
                rules={{ required: t('login.validation.email') }}
                error={errors.email?.message}
                autoComplete="email"
                autoCapitalize="none"
                spellCheck={false}
              />
              <ErrorMessageRhf errors={errors} fieldName="root" />
            </>
          }
          footer={
            <>
              <PrimaryButton
                isLoading={isLoading}
                type="submit"
                className={DEFAULT_AUTH_FORM_CLASSES.BUTTON}
              >
                {t('security.registration.submit')}
              </PrimaryButton>
              <p
                className={twMerge(
                  DEFAULT_AUTH_FORM_CLASSES.FOOTER_HELP_TEXT_BASE,
                  'text-neutral-300',
                )}
              >
                {t('header_navigation.sing-in-question')}{' '}
                <Link className="text-brand-primary" href={'/login'}>
                  {t('security.login.title')}
                </Link>
              </p>
            </>
          }
        />
      </form>
    </>
  )
}
